import { FC } from 'react';
import { Button, Dialog, DialogContent, DialogProps, Stack, Typography } from '@mui/material';

export interface NotesGeneratorClearDialogProps extends DialogProps {
  onClearConfirmResult?(result: 'Confirmed' | 'Canceled'): void;
}

export const NotesGeneratorClearDialog: FC<NotesGeneratorClearDialogProps> = ({ onClearConfirmResult, ...props }) => {
  const handleConfirm = (): void => {
    onClearConfirmResult?.('Confirmed');
  };

  const handleCancel = (): void => {
    onClearConfirmResult?.('Canceled');
  };

  return (
    <Dialog
      {...props}
      sx={{
        '.MuiPaper-root': {
          width: 300,
        },
      }}
    >
      <DialogContent sx={{ padding: 20 }}>
        <Stack direction='column' alignItems='center' justifyContent='center' gap='15px'>
          <Typography sx={{ fontSize: 16, fontWeight: 700, lineHeight: '22px' }}>Are you sure?</Typography>

          <Typography sx={{ fontSize: 14, fontWeight: 400, lineHeight: '20px', textAlign: 'center' }}>
            This will clear the response field. This action cannot be undone.
          </Typography>

          <Stack
            sx={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '10px',
              width: '100%',
            }}
          >
            <Button variant='outlined' onClick={handleCancel}>
              Cancel
            </Button>

            <Button color='primary' variant='contained' onClick={handleConfirm}>
              Yes
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default NotesGeneratorClearDialog;
